import { ThemeUIElementSettings } from '@frontend/casino-ui/shared';

export const themeButtonUISettings: ThemeUIElementSettings = {
    'borgata-2': {
        button: {
            searchcancel: { isInverse: true },
        },
    },
    'giocodigitale': {
        button: {
            searchcancel: { isInverse: true },
        },
    },
    'danske-spil': {
        button: {
            searchcancel: { isInverse: true },
        },
    },
    'gamebookers': {
        button: {
            searchcancel: { isInverse: true },
        },
    },
    'sportingbet': {
        button: {
            searchcancel: { isInverse: true },
        },
    },
    'party-poker': {
        button: {
            searchcancel: { isInverse: true },
        },
    },
};
